import React from 'react';
import { bool } from 'prop-types';
import { translate } from 'react-i18next';
import { Text, Avatar } from 'wix-style-react';
import ReviewStars from '../ReviewStars/ReviewStars';
import classnames from 'classnames';
import s from './expertBaseDetails.scss';
import { ARENA_PROFILE_PAGE_URL } from '../../../utils/constants';
import { Link } from 'react-router-dom';

const ExpertBaseDetails = ({
  t,
  id,
  name,
  username,
  profilePhoto,
  shortDescription,
  reviewsScore,
  totalReviews,
  totalProjects,
  horizontalLayout,
  location,
  onClick,
}) => {
  return (
    <div
      className={classnames(s.root, {
        [s.left]: horizontalLayout,
        [s.top]: !horizontalLayout,
        [s.clickable]: !!onClick,
      })}
      data-hook="expert-base-details"
    >
      <div
        className={classnames(s.expertAvatar)}
        data-hook="expert-card-avatar-wrapper"
      >
        <Avatar
          dataHook="expert-card-avatar"
          color="A1"
          imgProps={{
            src: profilePhoto,
          }}
          name={name}
          size="size72"
        />
      </div>
      <div className={s.generalInfo}>
        <Text
          weight="bold"
          size="medium"
          secondary={false}
          light={false}
          ellipsis={true}
          dataHook="expert-card-name"
        >
          {name}
        </Text>
        <Text
          tagName="div"
          weight="normal"
          size="small"
          secondary={false}
          light={false}
          dataHook="expert-card-short-description"
          className={s.desc}
        >
          {shortDescription}
        </Text>
        {location && (
          <Text
            className={s.location}
            tagName="div"
            weight="thin"
            size="small"
            secondary={true}
            light={false}
            dataHook="expert-card-location"
          >
            {location}
          </Text>
        )}
        <div
          className={s.expertScore}
          data-hook="expert-card-reviews-score-stars"
        >
          {totalReviews > 0 && (
            <span>
              <ReviewStars
                fullStars={reviewsScore}
                dataHook="expert-card-stars-score"
              />
              <Text
                weight="thin"
                size="small"
                secondary={true}
                light={false}
                className={s.expertScoreText}
                dataHook="expert-card-total-reviews"
              >
                {t('client-expertview-card-reviews', {
                  count: totalReviews,
                })}
              </Text>
            </span>
          )}
          {totalProjects && (
            <Text
              weight="thin"
              size="small"
              secondary={true}
              light={false}
              className={totalReviews > 0 ? s.expertScoreText : ''}
              dataHook="expert-card-total-projects"
            >
              {t('client-expertview-card-projects', {
                count: totalProjects,
              })}
            </Text>
          )}
        </div>
      </div>
      <Link
        data-hook="expert-base-details-link"
        to={`${ARENA_PROFILE_PAGE_URL}/${username}`}
        onClick={() => onClick && onClick(id, username, reviewsScore)}
        className={classnames(s.baseHref, {
          [s.hide]: !onClick,
        })}
      />
    </div>
  );
};

ExpertBaseDetails.propTypes = {
  horizontalLayout: bool,
};
ExpertBaseDetails.defaultProps = {
  horizontalLayout: false,
};

export default translate()(ExpertBaseDetails);
